export default __webpack_public_path__ + "static/volunteer-banner-bg-4dfa114a745eae38e2c5ddecec7a5592.jpg";